var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-info-checkbox"},[(_vm._content)?_c('div',_vm._l((_vm._content),function(item,index){return _c('div',{key:index},[_vm._v(_vm._s(item))])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }